import React, { useContext } from "react"
import styled from "styled-components"
import { actions } from "../../shared/constants"
import { createHostAction } from "../createHostAction"
import GameContext from "../../../Context/GameContext"

const Wrap = styled.div`
  margin-top: 100px;
`

/** in case of refresh, the socket connection and Game are restored but manual action could be needed to get the most recent gameState */
export const Reconnect = () => {
  const { onAction } = useContext(GameContext)

  const handleReconnect = () => {
    onAction(createHostAction(actions.HOST_RECONNECT))
  }

  // useEffect(() => {
  //   console.log("no automatic FE reconnect")
  //   // eslint-disable-next-line
  // }, [])

  return (
    <Wrap>
      <h1>Opnieuw verbinden</h1>
      <p>Even geduld, dit gebeurt automatisch.</p>
      <button onClick={handleReconnect}>Manueel verbinden</button>
    </Wrap>
  )
}
